<header>
  <div class="">
    <div class="logo-login ">
      <div class="logo-login-main">
        <div class="img-logo">
          <img style="width: 90px; height: 41px; margin-top: -5px;" src="./assets/img/logo-projects/Logo.png">
        </div>
        <div class="title-logo">
          <div class="title-red">
          </div>
          <div class="title-blue">
            <span>HỆ THỐNG QUẢN LÝ NGƯỜI KHUYẾT TẬT</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<div class="">
  <nz-card nzTitle="CHỌN LOẠI KHẢO SÁT">
    <div nz-card-grid [ngStyle]="gridStyle">Content</div>
    <div nz-card-grid [ngStyle]="gridStyle">Content</div>
  </nz-card>
</div>
<footer>
  <div class="container-fuild">
    <div class="copyright-login text-center">
      <p></p>
    </div>
  </div>
</footer>

<ng-template #titleTemplate>
  <i nz-icon nzType="ellipsis"></i>
</ng-template>